<template>
    <!-- main start  -->
    <div id="main">
        <!-- Main Header -->
        <MainHeader />
        
        <!-- Top Header -->
        <div class="top-header top-header-half">
            <div class="page-subtitle">
                <span></span>
            </div>
            <router-link to="/contact" class="single-page-fixed-row-link">
                <i class="fal fa-envelope"></i> <span>Get In Touch</span>
            </router-link>
        </div>
        <!-- top-header end-->
        
        <!-- wrapper  -->	
        <div id="wrapper">
            <!-- content-holder  -->	
            <div class="content-holder" data-pagetitle="Home">
                <!-- Navigation -->
                <Navigation />
                
                <!-- Hero Slider -->
                <HeroSlider />
                
                <!-- content-->
                <div class="content">
                    <!--fixed-column-wrap-->
                    <div class="fixed-column-wrap init_fx-column fcw_mob-hidden">
                        <!--fixed-column-wrap-content-->
                        <div class="fixed-column-wrap-content">
                            <div class="fixed-column-wrap_bg">
                                <div class="bg bg-scroll" data-bg="/assets/img/bg/4.jpg"></div>
                                <div class="overlay"></div>
                                <div class="column-image-anim"></div>
                                <div class="hero-scroll-down-notifer">
                                    <div class="scroll-down-wrap">
                                        <div class="mousey">
                                            <div class="scroller"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="fixed-column-dec"></div>
                            </div>
                            <!--fixed-column-wrap_title-->
                            <div class="fixed-column-wrap_title">
                                <h2><span>01. About Us</span></h2>
                            </div>
                            <!--fixed-column-wrap_title end-->
                            <div class="scroll-notifer">Scroll Down</div>
                            <div class="fwc-dec fwc-dec_top"></div>
                            <div class="fwc-dec fwc-dec_right"></div>
                            <div class="fixed-column-wrap_dec"></div>
                        </div>
                        <!--fixed-column-wrap-content end-->
                    </div>
                    <!--fixed-column-wrap end-->
                    
                    <!--column-wrap--> 
                    <div class="column-wrap">
                        <!--column-wrap-container -->   
                        <div class="column-wrap-container white-bg fl-wrap">
                            <div class="col-wc_dec"></div>
                            
                            <!-- About Section -->
                            <AboutSection />
                            
                            <!-- Featured Projects -->
                            <FeaturedProjects />
                            
                            <!-- Services Section -->
                            <ServicesSection />
                            
                            <!-- Video Section -->
                            <HomeVideoSection />
                            
                            <!-- Team Section -->
                            <!-- <TeamSection /> -->
                            
                            <!-- Section Separator -->
                            <div class="section-separator fl-wrap"><span></span></div>
                            
                            <!-- Testimonials Section -->
                            <TestimonialsSection />
                            
                        </div>
                        <!--column-wrap-container end-->  
                        
                        <!--scroll-fixed-column-content-->
                        <div class="scroll-fixed-column-content stf-con_mob-hidden fl-wrap">
                            <div class="container">
                                <!--page-scroll-nav-->
                                <div class="page-scroll-nav fl-wrap">
                                    <nav class="scroll-init color2-bg">
                                        <ul class="no-list-style">
                                            <li>
                                                <a class="scroll-link fbgs actscr-link" href="#sec1" data-bgscr="/assets/img/bg/3.jpg" data-bgtex="01. About Us">
                                                    <span>About</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a class="scroll-link fbgs" href="#sec2" data-bgscr="/assets/img/bg/4.jpg" data-bgtex="02. Portfolio">
                                                    <span>Cases</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a class="scroll-link fbgs" href="#sec3" data-bgscr="/assets/img/bg/5.jpg" data-bgtex="03. Services">
                                                    <span>Services</span>
                                                </a>
                                            </li>
                                            <!-- <li>
                                                <a class="scroll-link fbgs" href="#sec4" data-bgscr="/assets/img/bg/long/8.jpg" data-bgtex="04. Our Team">
                                                    <span>Team</span>
                                                </a>
                                            </li> -->
                                            <li>
                                                <a class="scroll-link fbgs" href="#sec5" data-bgscr="/assets/img/bg/8.jpg" data-bgtex="04. Clients">
                                                    <span>Clients</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                                <!--page-scroll-nav end-->							
                            </div>
                            <div class="arrowpagenav"></div>
                        </div>
                        <!--scroll-fixed-column-content end-->
                    </div>
                    <!--column-wrap end-->					
                    <div class="limit-box fl-wrap"></div>
                </div>
                <!-- content end  -->
                
                <!-- Footer -->
                <div class="height-emulator fl-wrap"></div>
                <AppFooter />
                
            </div>
            <!-- content-holder end -->
        </div>
        <!-- wrapper end -->
    </div>
    <!-- Main end -->
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
import Navigation from '@/components/Navigation.vue'
import HeroSlider from '@/components/HeroSlider.vue'
import AboutSection from '@/components/AboutSection.vue'
import FeaturedProjects from '@/components/FeaturedProjects.vue'
import ServicesSection from '@/components/ServicesSection.vue'
import HomeVideoSection from '@/components/HomeVideoSection.vue'
import TeamSection from '@/components/TeamSection.vue'
import TestimonialsSection from '@/components/TestimonialsSection.vue'
import AppFooter from '@/components/Common/AppFooter.vue'

export default {
    name: 'Home',
    components: {
        MainHeader,
        Navigation,
        HeroSlider,
        AboutSection,
        FeaturedProjects,
        ServicesSection,
        HomeVideoSection,
        TeamSection,
        TestimonialsSection,
        AppFooter
    }
}
</script>
